import './App.css';
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { auth, db } from './firebase';
import { doc, getDoc } from 'firebase/firestore';

import Login from './auth/Login';
import Register from './auth/Register';
import Header from './panel/Header';
import Menu from './panel/Menu';
import Footer from './panel/Footer';

import Dashboard from './components/Dashboard';
import Department from './components/Department';
import Products from './components/Products';
import Avakregister from './components/Avakregister';
import Viewavakdata from './components/Viewavakdata';
import Avakdetails from './components/Avakdetails';
import Javakregister from './components/Javakregister';
import Viewjavakdata from './components/Viewjavakdata';
import Javakdetails from './components/Javakdetails';
import Storeledger from './components/Storeledger';
import Ledgerdetails from './components/Ledgerdetails';
import Purchaseorder from './components/Purchaseorder';
import Viewpo from './components/Viewpo';
import Poitemdetails from './components/Poitemdetails';
import Printpo from './components/Printpo';
import Productledger from './components/Productledger';

import Requisitions from './components/Requisitions';
import Viewrequisition from './components/Viewrequisition';
import Printrqui from './components/Printrqui';

function App() {
  const [user, setUser] = useState();

  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      setUser(user);
    });
  });




  return (
    <div className="wrapper">
      {
        !user ?
          <Router>
            <Routes>
              <Route path='/' element={<Login />} />
              <Route path='/login' element={<Login />} />
              <Route path='/Register' element={<Register />} />
            </Routes>
          </Router>
          :
          <>
            <Menu />
            <Header />
            <Router>
              <Routes>
                <Route path='/' element={<Dashboard />} />
                <Route path='/home' element={<Dashboard />} />
                <Route path='/departments' element={<Department />} />
                <Route path='/products' element={<Products />} />
                <Route path='/avak-register' element={<Avakregister />} />
                <Route path='/view-avak-data' element={<Viewavakdata />} />
                <Route path='/avak-details/:documentId' element={<Avakdetails />} />
                <Route path='/javak-data' element={<Javakregister />} />
                <Route path='/view-javak-data' element={<Viewjavakdata />} />
                <Route path='/javak-details/:documentId' element={<Javakdetails />} />
                <Route path='/store-ledger' element={<Storeledger />} />
                <Route path='/view-store-ledger/:documentId' element={<Ledgerdetails />} />
                <Route path='/view-products/:documentId' element={<Productledger />} />

                <Route path='/purchase-orders' element={<Purchaseorder />} />
                <Route path='/view-purchase-order' element={<Viewpo />} />
                <Route path='/poitem-details/:documentId' element={<Poitemdetails />} />
                <Route path='/print-po/:documentId' element={<Printpo />} />
                
                <Route path='/requisitions' element={<Requisitions />} />
                <Route path='/view-requisitions' element={<Viewrequisition />} />
                <Route path='/print-requisitions/:documentId' element={<Printrqui />} />


              </Routes>
            </Router>
            <Footer />
          </>
      }

    </div >
  );
}

export default App;
